import { computed } from 'vue';
import type { ElementProperties, ElementType, FormElement } from './form.types';
import { useElementContainerStyles } from './useElementContainerStyles';
import { useLabelPosition } from './useLabelPosition';
import { useEditableField } from './useFormBuilderReadonly';

export function useFormBuilderDisplayInput(
  getElement: () => FormElement & { properties: ElementProperties },
  elementType: ElementType
) {
  const properties = computed(() => getElement().properties);

  const inputValue = computed(() => properties.value.value ?? '');

  const { isLabelLeft, inputClasses, labelClasses, labelStyles } = useLabelPosition(properties);

  const { containerStyles } = useElementContainerStyles(properties, elementType);

  const isEditable = useEditableField(() => properties.value.editable);

  return {
    inputValue,
    isLabelLeft,
    inputClasses,
    labelClasses,
    labelStyles,
    containerStyles,
    isEditable,
  };
}
